module.exports = __webpack_public_path__ + "img/70.2c5c8df4.jpg";